import { DatePipe } from '@angular/common';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgbCollapseModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { SharedModule } from '../shared/shared.module';
import {
  AccountService,
  ErrorComponent,
  HeaderComponent,
  NavigationComponent,
  NotFoundComponent,
  PreloadComponent,
  RoutingModule,
  LoadingOverlayComponent,
  ExternalToolbarComponent
} from './';
import { ExternalErrorComponent } from './external-error/external-error.component';
import { ReloadRequired } from '../shared/reload-guard';
import { HomepageComponent } from './homepage/homepage.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { NoProductsLandingPageComponent } from './no-products-landing-page/no-products-landing-page.component';
import { TokenExchangeService } from '../shared/token-exchange.service';
import { UserModule } from '../user/user.module';
import { ExternalAccessLandingPageComponent } from './external-access-landing-page/external-access-landing-page.component';
import { CustomerAccountService } from '../shared/customer-account.service';
import { OnboardingService } from '../shared/onboarding.service';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { WebsiteAdminAccessComponent } from './onboarding/website-admin-access/website-admin-access.component';
import { CampaignSurveyComponent } from './onboarding/campaign-survey/campaign-survey.component';
import { VerticalService } from '../shared/vertical.service';
import { GoogleTagManagerSetupComponent } from './google-tag-manager-setup/google-tag-manager-setup.component';

const routes: Routes = [
  {
    path: 'not-found',
    component: NotFoundComponent,
    canActivateChild: [ReloadRequired]
  },
  {
    path: 'error',
    component: ErrorComponent,
    canActivateChild: [ReloadRequired]
  },
  {
    path: 'business-center-error',
    component: ExternalErrorComponent,
    canActivateChild: [ReloadRequired]
  },
  {
    path: 'maintenance',
    component: MaintenanceComponent
  },
  {
    path: '**',
    redirectTo: '/not-found',
    canActivateChild: [ReloadRequired]
  }
];

@NgModule({
  imports: [FormsModule,
    RoutingModule,
    SharedModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UserModule,
    RouterModule.forRoot(routes, {}),
    NgbCollapseModule,
    NgbModule
  ],
  providers: [
    AccountService,
    CustomerAccountService,
    TokenExchangeService,
    OnboardingService,
    VerticalService,
    DatePipe
  ],
  declarations: [
    NavigationComponent,
    HeaderComponent,
    LoadingOverlayComponent,
    PreloadComponent,
    NotFoundComponent,
    ErrorComponent,
    ExternalErrorComponent,
    ExternalToolbarComponent,
    HomepageComponent,
    MaintenanceComponent,
    NoProductsLandingPageComponent,
    ExternalAccessLandingPageComponent,
    OnboardingComponent,
    WebsiteAdminAccessComponent,
    CampaignSurveyComponent,
    GoogleTagManagerSetupComponent
  ],
  exports: [
    RoutingModule,
    NavigationComponent,
    HeaderComponent,
    LoadingOverlayComponent,
    ExternalToolbarComponent
  ]
})
export class StructureModule { }
